module.exports = __webpack_public_path__ + "media/sy.6e60e343.mp4";